import React from 'react';
import Modal from '../../../../components/ui/Modal';
import { Button } from '../../../../components/ui/Button';
import type { PixKeyType as DomainPixKeyType } from '../../../../domain/pix/types';
import type { OrganizationPixKey } from '../../../../domain/pix/types';
import { PixKeyFormFields } from '../../../settings/pix/components/PixKeyFormFields';

interface ChatPixEditFormProps {
    savedKey: OrganizationPixKey | null;
    type: DomainPixKeyType;
    pixKey: string;
    name: string;
    isSubmitting: boolean;
    canSubmit: boolean;
    hasSaveAndSend: boolean;
    onTypeChange: (v: DomainPixKeyType) => void;
    onPixKeyChange: (v: string) => void;
    onNameChange: (v: string) => void;
    onClose: () => void;
    onSubmit: (e: React.FormEvent) => void;
}

export const ChatPixEditForm: React.FC<ChatPixEditFormProps> = ({
    savedKey,
    type,
    pixKey,
    name,
    isSubmitting,
    canSubmit,
    hasSaveAndSend,
    onTypeChange,
    onPixKeyChange,
    onNameChange,
    onClose,
    onSubmit,
}) => (
    <form onSubmit={onSubmit}>
        <Modal.Header onClose={onClose}>Enviar chave PIX</Modal.Header>
        <Modal.Body>
            <PixKeyFormFields
                type={type}
                pixKey={pixKey}
                name={name}
                onTypeChange={onTypeChange}
                onPixKeyChange={onPixKeyChange}
                onNameChange={onNameChange}
                disabled={isSubmitting}
            />
        </Modal.Body>
        <Modal.Footer>
            <Button type="button" variant="outline" onClick={onClose} disabled={isSubmitting}>
                Cancelar
            </Button>
            <Button type="submit" disabled={!canSubmit || (!savedKey && !hasSaveAndSend)}>
                {isSubmitting ? 'Enviando...' : 'Salvar e enviar'}
            </Button>
        </Modal.Footer>
    </form>
);
